import api from "../apiClient"

/**
 * auth
 */

export const login = async (credentials) => {
    const response = await api.post("/auth/login", credentials)
    return response.data
}

export const logout = async () => {
    const response = await api.post("/auth/logout")
    return response.data
}
  
export const refresh = async () => {
  const response = await api.post("/auth/refresh")
  return response.data
}